module.exports = __webpack_public_path__ + "img/iphone-charging-FRANCE-en.445c4f33.png";